import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = { openOnConnect: Boolean }

  connect() {
    this.restoreFocus = this.restoreFocus.bind(this)
    this.dialogTarget.addEventListener("close", this.restoreFocus)
    if (this.openOnConnectValue) this.open()
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this.restoreFocus)
  }

  open(event) {
    this.openingTrigger = event?.currentTarget
    if (this.dialogTarget.open) return

    this.dialogTarget.showModal()
    window.requestAnimationFrame(() => {
      const initialFocus = this.dialogTarget.querySelector("[data-dialog-initial-focus]")
      const focusTarget = initialFocus || this.focusableElements[0] || this.dialogTarget
      focusTarget.focus()
    })
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  trapFocus(event) {
    if (event.key !== "Tab") return

    const focusableElements = this.focusableElements
    if (focusableElements.length === 0) {
      event.preventDefault()
      this.dialogTarget.focus()
      return
    }

    const first = focusableElements[0]
    const last = focusableElements[focusableElements.length - 1]
    const activeElement = this.dialogTarget.ownerDocument.activeElement
    const focusIsOutside = !this.dialogTarget.contains(activeElement)

    if (event.shiftKey && (activeElement === first || focusIsOutside)) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && (activeElement === last || focusIsOutside)) {
      event.preventDefault()
      first.focus()
    }
  }

  restoreFocus() {
    if (this.openingTrigger?.isConnected) this.openingTrigger.focus()
    this.openingTrigger = null
  }

  get focusableElements() {
    const selector = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled]):not([type='hidden'])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])"
    ].join(",")

    return Array.from(this.dialogTarget.querySelectorAll(selector)).filter(element => (
      !element.hidden && element.getClientRects().length > 0
    ))
  }
}
